import { render, staticRenderFns } from "./ChangeStatusModal.vue?vue&type=template&id=420e119b&lang=pug"
import script from "./ChangeStatusModal.vue?vue&type=script&lang=ts"
export * from "./ChangeStatusModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports